
import { LoginPage } from './../pages/login/login';
import { Component } from '@angular/core';
import { Platform, App, AlertController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NetworkProvider } from '../providers/network/network';
import { Network } from '@ionic-native/network';
import { AppInfo } from './credentials';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  rootPage:any = LoginPage;
  protected app_version: string;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public  app: App,
    public alertCtrl: AlertController,
    public events: Events,
    public network: Network,
    public networkProvider: NetworkProvider
    ) {

    //this.dbService = dbService;

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
     // statusBar.styleDefault();
      statusBar.overlaysWebView(true);
      //statusBar.show();
    //  statusBar.styleLightContent();
    //  statusBar.backgroundColorByHexString('#1c1e22');
     // this.dbService.init();
    //  splashScreen.hide();

      this.networkProvider.initializeNetworkEvents();

      // Offline event
      this.events.subscribe('network:offline', () => {
        alert('network:offline ==> ' + this.network.type);
      });

      // Online event
      this.events.subscribe('network:online', () => {
        alert('network:online ==> ' + this.network.type);
      });

      /*
    this.appVersion.getVersionNumber().then(
      (versionNumber) => {
        console.log(versionNumber);
        this.app_version = versionNumber;
      },
      (error) => {
        console.log(error);
      });
      */
      this.app_version = AppInfo.Version


    platform.registerBackButtonAction(() => {

      let nav = app.getActiveNavs()[0];
      let activeView = nav.getActive();

      if(activeView.name === "BooksLocalPage" || activeView.name === "BooksOnlinePage") {

        /*
          if (nav.canGoBack()){ //Can we go back?
              nav.pop();
          } else {
              const alert = this.alertCtrl.create({
                  title: 'App termination',
                  message: 'Do you want to close the app?',
                  buttons: [{
                      text: 'Cancel',
                      role: 'cancel',
                      handler: () => {
                          console.log('Application exit prevented!');
                      }
                  },{
                      text: 'Close App',
                      handler: () => {
                          platform.exitApp(); // Close this application
                      }
                  }]
              });
              alert.present();
          }

          */

      }else{
        nav.pop();

      }
  });


  });
  }



}



// WEBPACK FOOTER //
// ./src/app/app.component.ts